import request from './request'
import { apiIA } from './config'

export default {
  listarUsuarios () {
    return request({
      url: '/usuario/listarUsuarios',
      method: 'get'
    })
  },
  buscarUsuario (idUsuario) {
    return request({
      url: `/usuario/buscarUsuario?id=${idUsuario}`,
      method: 'get'
    })
  },
  cadastrarUsuario (obj) {
  // console.log(obj)
    return request({
      url: '/usuario/cadastrarUsuario',
      method: 'post',
      data: obj
    })
  },
  vincularPacoteExames (usuarios, idPacoteExames) {
    return request({
      url: 'usuario/vincularPacoteExames',
      method: 'post',
      data: {
        'usuarios': usuarios,
        'pacote': idPacoteExames
      }
    })
  },
  buscarTelefonePorCPF (cpf) {
    return apiIA.get(`/smv2/esquecisenha/${cpf}`)
  },
  validarTelefone (telefone) {
    return apiIA.post(`/areacliente/enviosms/${telefone}`)
  },
  validarWatsApp (telefone) {
    return apiIA.post(`/areacliente/enviowhatsapp/${telefone}`)
  },
  validarCodigo (codigo, telefone) {
    return apiIA.post(`/areacliente/validar`,
      {
        'codigo': codigo,
        'numero': telefone
      })
  }

}
